<script>
import API, {showToasterError} from "../../../API";
import toaster from "../../common/toaster";

import SelectField from "../../common/select-field.vue";
import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import Loading from "../../common/loading.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogBase from "../../dialog/components/dialog-base.vue";
import TextField from "../../common/text-field.vue";
import PropertyTable from "../../common/property-table.vue";
import Fileupload from "../dynamic_fields/fileupload.vue";
import ClientDialogCommonTab from "./client-dialog-common-tab.vue";
import ClientDialogLocationTab from "./client-dialog-location-tab.vue";
import ClientDialogSwitchOffTimesTab from "./client-dialog-switch-off-times-tab.vue";
import ClientData from "./ClientData";
import {transformCapitalizedJSONIntoSnakeCase} from "../../../utility";
import switchOffTimesHelper from "../switchOffTimes/switchOffTimesHelper";

export default {
    name: "client-dialog",
    components: {
        ClientDialogSwitchOffTimesTab,
        ClientDialogLocationTab,
        ClientDialogCommonTab,
        PropertyTable, TextField, DialogBase, DialogHeader, Loading, DialogActionbar,
                DialogBody, SelectField, Fileupload},
    data() {
        return {
            showDialog: false,
            processing: false,
            selectedTab: null,

            id: '',
            name: '',
            data: new ClientData()
        }


    },
    computed: {
        translations() {
            return {
                editSuccess: Lang.langGet("Client edited successfully."),
                failedToEdit: Lang.langGet("Failed to edit client:"),
                edit: Lang.langGet("Edit client \":client\"", {'client': this.name})
            }
        },
        tabs() {
            return ['Location', 'Common', 'Switch-Off Times'];
        },
        minHeight() {
            return window.innerHeight * 0.7;
        }
    },
    methods: {
        translateTab(tab) { return Lang.langGet(tab) },
        show() { this.showDialog = true; },
        hide() { this.showDialog = false; },

        handleClose() { this.hide(); },
        handleChange(property, value) {
            this.data.updateProperty(property, value);
        },
        handleSwitchOffTimesChange(value) {
            this.data.updateProperty('switchOffTimes', value);
        },
        refreshList() {
            EaseEventBus.fire('updateClientList');
        },
        async handleSave(){
            this.processing = true;
            const url = '/administration/client/update';

            const data = this.data.prepareForAPIRequest();

            data.projectId = Laravel.activeProject;
            if (this.id) {
                data.id = this.id;
            }

            const snakeCaseData = transformCapitalizedJSONIntoSnakeCase(data);
            snakeCaseData.switch_off_times = switchOffTimesHelper.fixCapitalizationOfProperties(snakeCaseData.switch_off_times);
            const body = JSON.stringify(snakeCaseData);

            const result = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Csrf-Token': Laravel.csrfToken
                },
                body
            });

            this.processing = false;

            if (!result.ok) {
                this.errored = true;
                const data = await result.json();
                showToasterError(data, this.translations.failedToEdit);
            }
            else {
                this.errored = false;
                toaster.success(this.translations.editSuccess);
                this.refreshList();
                this.hide();
            }
        },
        async load() {
            this.processing = true;
            const url = '/administration/client/edit/data';
            const api = new API(url);

            this.name = '';

            const result = await api.post({id: this.id, projectId: Laravel.activeProject});

            this.processing = false;
            if (result.errored) {
                this.errored = true;
            }
            else {
                this.errored = false;
                this.name = result.name;
                this.data.update(result);
            }
        }
    },
    mounted: function () {
        EaseEventBus.listen('clientEdit', (id) => {
            this.id = id;
            this.show();
            this.load();
        });
    }
}

</script>

<template>
    <dialog-base v-if="showDialog"
        :maxWidth="620"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            class="text-truncate"
            @close="handleClose"
            :title="translations.edit"
        />
        <loading :loading="processing"/>
        <dialog-body :minHeight="minHeight">
            <v-tabs
                v-model="selectedTab"
                centered
                grow
            >
                <v-tab :key="tab" v-for="tab in tabs">
                    {{ translateTab(tab) }}
                </v-tab>
            </v-tabs>
            <v-tabs-items
                v-model="selectedTab"
            >
                <v-tab-item :key="tab" v-for="tab in tabs">
                    <v-card-text>
                        <client-dialog-location-tab v-if="tab === 'Location'"
                            :client-data="data"
                            @input="handleChange"
                        />
                        <div v-if="tab === 'Common'" class="client-tab-overflow">
                            <client-dialog-common-tab
                                :clientData="data"
                                @input="handleChange"
                            />
                        </div>
                        <client-dialog-switch-off-times-tab v-if="tab === 'Switch-Off Times'"
                            :clientData="data"
                            @input="handleSwitchOffTimesChange"
                        />
                    </v-card-text>
                </v-tab-item>
            </v-tabs-items>
        </dialog-body>
        <dialog-actionbar
            :disableSave="data.isInvalid()"
            @close="handleClose"
            @save="handleSave"
        />
    </dialog-base>
</template>

<style scoped>
    .client-tab-overflow {
        overflow: scroll;
        height: 60vh;
    }
</style>
